// @ts-nocheck
import React from 'react';
import { ScraperStatus } from './types';

interface Props {
  scraperStatus: ScraperStatus;
  onFinishImport: () => void;
}

const ScraperStatusCard: React.FC<Props> = ({ scraperStatus, onFinishImport }) => {
  if (scraperStatus.status === 'idle') return null;

  return (
    <div className="bg-blue-600 rounded-xl overflow-hidden shadow-lg border border-blue-700 text-white">
      <div className="px-6 py-4 bg-blue-700 font-bold flex justify-between items-center">
        <span>Status: {scraperStatus.status.toUpperCase()}</span>
        <div className="flex space-x-4">
          <div className="text-xs">
            Collected: <span className="font-mono text-base">{scraperStatus.progress.collected}</span>
          </div>
          <div className="text-xs">
            Imported: <span className="font-mono text-base">{scraperStatus.progress.imported}</span>
          </div>
        </div>
      </div>
      <div className="p-6">
        <div className="flex items-center space-x-4">
          <div className="animate-pulse w-4 h-4 bg-white rounded-full" />
          <div className="flex-1">
            <p className="text-sm opacity-80 uppercase tracking-wider font-semibold">Current Activity</p>
            <p className="text-lg font-bold">{scraperStatus.status === 'scraping' ? 'Collecting posts from page...' : 'Importing media to Firestore...'}</p>
          </div>
        </div>
        {scraperStatus.error && (
          <div className="mt-4 p-4 bg-red-500/20 border border-red-500/40 rounded-lg text-sm font-medium">
            Error: {scraperStatus.error}
          </div>
        )}
        {scraperStatus.status === 'scraping' && (
          <button
            onClick={onFinishImport}
            className="mt-4 w-full bg-green-500 hover:bg-green-400 text-white py-3 rounded-lg text-sm font-black transition-all shadow-lg flex items-center justify-center gap-2"
          >
            <span>✓</span>
            <span>FINISH & IMPORT ({scraperStatus.progress.collected} posts)</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default ScraperStatusCard;
